export const tileImageCacheKeyPrefix = "t_";
export const tileAtlasImageCacheKeyPrefix = "a_";
export const generatedImageCacheKeyPrefix = "g_";
export const animationCacheKeyPrefix = "an_";